import lodash from 'lodash';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TablePagination,
    TableContainer,
} from '@material-ui/core';
import {Icon, Tag} from 'antd';
import Moment from 'react-moment';
import TableLoader from '../../../../../components/table/TableLoader';
import TableNoData from '../../../../../components/table/TableNoData';


const tableCols = [
    { content: '#', width: '1%', align: 'center' },
    { content: 'Date', width: '15%', align: 'center' },
    { content: 'Disposition', align: 'left' },
];

class LeadDispositionTab extends Component {
    constructor(props) {
        super(props);

        this.state = {
            rpp: 10,
            page: 0,
        };
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = (event) => {
        this.setState({ rpp: event.target.value });
    };

    render() {
        const { page, rpp } = this.state;
        const { dispositions, isLoading } = this.props;
        const dataFrom = page * rpp;
        const dataTo = dataFrom + rpp;
        const cuttedData = dispositions?.length ? dispositions?.slice(dataFrom, dataTo) : null;

        return (
            <Fragment>
                <TableContainer>
                    <Table size="small" aria-label="lead disposition table">
                        <TableHead>
                            <TableRow>
                                {
                                    tableCols.map((title) => (
                                        <TableCell
                                            key={title}
                                            align={title.align}
                                            style={{
                                                width: [title.width],
                                            }}
                                        >
                                            {title.content}
                                        </TableCell>
                                    ))
                                }
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                !isLoading && lodash.isEmpty(dispositions) && <TableNoData colSpan={tableCols.length} />
                            }
                            {
                                isLoading
                                    ? <TableLoader colSpan={tableCols.length} />
                                    : cuttedData && cuttedData.map((item, index) => (
                                        <TableRow key={item._id || item.created_date}>
                                            <TableCell align={tableCols[0].align}>
                                                <span>{dataFrom + index + 1}</span>
                                            </TableCell>
                                            <TableCell align={tableCols[1].align} width={'15%'}>
                                                <span>
                                                    {
                                                    item?.created_date
                                                        ? (
                                                            <Moment format="D MMM YYYY | HH:mm">
                                                                {item?.created_date}
                                                            </Moment>
                                                        )
                                                        : '-'
                                                    }
                                                </span>
                                            </TableCell>
                                            <TableCell align={tableCols[2].align}>
                                                <span>
                                                    {item?.disposition ? item.disposition : '-'}
                                                    {
                                                        item?.is_chat_bot
                                                            ? (
                                                                <small>
                                                                    <Tag color="#28a745" className="tag">CHAT BOT</Tag>
                                                                </small>
                                                            )
                                                            : null
                                                    }
                                                </span>
                                            </TableCell>
                                        </TableRow>
                                    ))
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    component="div"
                    count={dispositions?.length}
                    rowsPerPage={rpp}
                    page={!dispositions?.length ? 0 : page}
                    backIconButtonProps={{ 'aria-label': 'Previous Page' }}
                    nextIconButtonProps={{ 'aria-label': 'Next Page' }}
                    onPageChange={this.handleChangePage}
                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                />
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => ({ ...state.Leads.Lead_profile.leadDisposition });

export default connect(mapStateToProps)(LeadDispositionTab);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Lead_disposition_tab/Lead_disposition_tab.js